import i18n from '@/lang/i18n'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { ColDef } from '@ag-grid-enterprise/all-modules'

export const sectionSubportionGridColumnDefs: (ColDef | ExportedColDef | ExportedColGroupDef)[] = [
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('globalLocator.labels.subportionTag'),
        colId: 'supLabel',
        field: 'subportionLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.technique'),
        field: 'assay.name',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.status'),
        field: 'status',
        type: AgGridColumnType.COMMON_SUBPORTION_STATUS,
        exportField: 'status.name',
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.requestDate'),
        colId: 'supRequestDate',
        field: 'requestDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME
    },
    {
        headerName: i18n.tc('globalLocator.labels.requester'),
        colId: 'requester.normalizedFullName',
        field: 'requesterPersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.cutDate'),
        colId: 'supCutDate',
        field: 'cutDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.cutTechnician'),
        colId: 'cutter.normalizedFullName',
        field: 'cutterPersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.incidents'),
        field: 'incidentsCount',
        type: AgGridColumnType.INCIDENT,
        exportType: AgGridExportType.INTEGER,
        minWidth: 200,
        flex: 1
    },
    {
        headerName: i18n.tc('globalLocator.labels.attachments'),
        field: 'attachmentsCount',
        type: AgGridColumnType.ATTACHMENT_COUNT,
        exportType: AgGridExportType.INTEGER,
        minWidth: 200,
        flex: 1
    },
    {
        headerName: i18n.tc('globalLocator.labels.stainingEntryDate'),
        colId: 'supAssayStartDate',
        field: 'assayStartDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.stainingEntryTechnician'),
        colId: 'assayStartResponsible.normalizedFullName',
        field: 'assayStartResponsiblePersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.stainingDepartureDate'),
        colId: 'supAssayEndDate',
        field: 'assayEndDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.stainingDepartureTechnician'),
        colId: 'assayEndResponsible.normalizedFullName',
        field: 'assayEndResponsiblePersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.assemblyEntryDate'),
        field: 'assemblyStartDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.assemblyEntryTechnician'),
        colId: 'assemblyStartResponsible.normalizedFullName',
        field: 'assemblyStartResponsiblePersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.assemblyDepartureDate'),
        field: 'assemblyEndDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.assemblyDepartureTechnician'),
        colId: 'assemblyEndResponsible.normalizedFullName',
        field: 'assemblyEndResponsiblePersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.deliveryDate'),
        colId: 'supDeliverDate',
        field: 'deliverDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.deliveryTechnician'),
        colId: 'deliveryResponsible.normalizedFullName',
        field: 'deliveryResponsiblePersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.scannerEntryDate'),
        field: 'scanStartDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.scannerEntryTechnician'),
        colId: 'scanStartResponsible.normalizedFullName',
        field: 'scanStartResponsiblePersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.scannerDepartureDate'),
        field: 'scanEndDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.scannerDepartureTechnician'),
        colId: 'scanEndResponsible.normalizedFullName',
        field: 'scanEndResponsiblePersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.cancellationDate'),
        field: 'supCancelDate',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.cancellationTechnician'),
        colId: 'cancelResponsible.normalizedFullName',
        field: 'cancelResponsiblePersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.observations'),
        colId: 'supNotes',
        field: 'notes',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('global.laboratory'),
        field: 'currentLaboratory.labName',
        type: AgGridColumnType.LABORATORIES,
        exportType: AgGridExportType.TEXT
    }
]
